import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const ICONS = ['i-bows', 'i-run', 'i-snow', 'i-goat'];

/** Бегущая строка (`#mq1` макета, генерируется в JS). `.mtrack` — flex-контейнер,
 *  `.ico`/`.dia`/`.txt` должны быть его непосредственными детьми (gap в CSS) — без обёрток. */
export function Marquee() {
  const { t } = useTranslation('landing');
  const items = t('marquee.items', { returnObjects: true }) as string[];

  return (
    <div className="marquee" aria-hidden="true">
      <div className="mtrack">
        {Array.from({ length: 4 }, (_, rep) => (
          <Fragment key={rep}>
            {items.map((text, i) => (
              <Fragment key={i}>
                <span className="txt">{text}</span>
                <i className="dia" />
                <i className={`ico ${ICONS[i % ICONS.length]}`} />
                <i className="dia" />
              </Fragment>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
